// extracted by mini-css-extract-plugin
export default {"coordinates-plane":"coordinates-plane_coordinates-plane__dUoLn"};